module.exports = __webpack_public_path__ + "img/cardLayout-04.b8af5351.png";